import { features } from "@/mocks/homeData";

export default function WhyChoose() {
  return (
    <section id="diferenciais" className="relative py-7 md:py-12 bg-background-50 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-5 md:mb-8 reveal">
            <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-3">
              Nossos diferenciais
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-primary-900 mb-3">
              Por que escolher a Eco Tour Turismo em Capitólio?
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 max-w-xl mx-auto">
              Cuidamos de cada detalhe para que o seu único trabalho seja aproveitar o passeio.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-8">
            {features.map((feature, index) => (
              <div
                key={feature.id}
                className={`reveal reveal-delay-${index + 1} flex items-center gap-3.5 md:flex-col md:gap-0 md:text-center bg-background-100 rounded-xl border border-background-200/70 p-4 md:p-7`}
              >
                <div className="w-11 h-11 md:w-14 md:h-14 shrink-0 md:mx-auto md:mb-4 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className={`${feature.icon} text-white text-xl md:text-2xl`} />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm md:text-base font-heading font-bold text-primary-900 mb-1 md:mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}